<template>
	<div class="drawer">
		<el-drawer
		size="400px"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:title="'追加订金'"
		:append-to-body="true"
		>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="活体名称:" :label-width="formLabelWidth">
								<span style="font-size: 14px;">{{row.order_item_list[0].goods_name}} ({{row.order_item_list[0].category_info.name}})</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:10px 10px;float: none;">
					<el-col :span="24">
						<span style="color:red;padding-left:98px;font-size: 14px;">当前订金金额{{curDingjinMoney}}元</span>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="再追加金额:" :label-width="formLabelWidth">
								<el-input v-model="num" @input="inputNum" style="width:260px;" placeholder="请输入追加金额" size="small"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:10px 10px;float: none;">
					<el-col :span="24">
						<span style="color:red;padding-left:98px;font-size: 14px;">追加后订金金额{{$public.jia(curDingjinMoney,num)}}元</span>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;margin-bottom:28px;">
					<el-col :span="24">
							<el-form-item label="销售人员:" :label-width="formLabelWidth">
								<el-select
								:disabled="staffLock"
								v-model="curStaffId"
								style="width:260px;" 
								multiple
								filterable
								placeholder="请选择"
								size="mini">
									<el-option popper-class="select" v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
									:value="item._id"></el-option>
								</el-select>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="备注:" :label-width="formLabelWidth">
								<el-input v-model="remark" type="textarea" :rows="4" style="width:260px;" placeholder="请输入备注" size="small"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">生成订单</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'100px',
				
				curDingjinMoney:0,
				num:'',
				
				// 销售人员
				curStaffId:[],
				staffLock:false,
				staffList:[],
				
				remark:'',
			}
		},
		computed:{
			dingjinOrder(){
				return this.$store.state.mendian.dingjinOrder;
			},
		},
		props:{
			row:{
				default:''
			}
		},
		mounted(){
			console.log(this.row)
			for(let i=0;i<this.dingjinOrder.length;i++){
				if(this.dingjinOrder[i].order_item_list[0].goods_id===this.row.order_item_list[0].goods_id){
					this.curDingjinMoney = this.$public.jia(this.curDingjinMoney,this.dingjinOrder[i].order_item_list[0].price)
				}
			}
			this.getStaffList()
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.$store.state.mendian.userController.map((controller)=>{
					if(controller.invitationType===4&&controller.userId.length>0){
						this.curStaffId = [controller.userId]
						this.staffLock = controller.lock
					}
				})
			})
		},
		methods: {
			inputNum(){
				this.num = this.$public.replaceGoodsDosage(this.num)
			},
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				if(this.$public.isNull(this.num)){
					this.$message({
						message: '请输入追加金额',
						type: 'error'
					});
					return 
				}
				let salesMans = []
				if(this.curStaffId.length===0){
					this.$message({
						message: '请选择销售人员！',
						type: 'error'
					});
					return 
				}else{
					for(let b=0;b<this.curStaffId.length;b++){
						for(let c=0;c<this.staffList.length;c++){
							if(this.staffList[c]._id==this.curStaffId[b]){
								salesMans.push({"userId": this.staffList[c]._id,"userName": this.staffList[c].basic_info.nick_name});
							}
						}
					}
				}
				let params = {
					"orderNo": this.row.no,
					"money": Number(this.num),
					"remark": this.remark,
					"salesMans": salesMans
				}
				this.$emit('submit',{type:'success',data:params})
			},
			// 销售人员
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
	.el-form-item{
		margin:0;
	}
</style>
